import './profilepanel.css'
import React, { useState, useEffect } from 'react'
import { Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Profile from './profile/profile';
import ProfileInsurance from './insurance/insurance';
import plan from '../../../../assets/images/plan.png';
import arrow from '../../../../assets/images/rightArrow.png';
import picUpload from '../../../../assets/images/upload.png';
import avatar from '../../../../assets/images/avatar_admin.png';
import { useHistory } from 'react-router-dom';

function ProfilePanel() {
    const location = useLocation()
    const history = useHistory()
    const [avatarPreview, setAvatarPreview] = useState(avatar);
    const [style, setStyle] = useState({
        a1: "a-bar",
        a2: ""
    })

    useEffect(() => {
        if (location.pathname === "/profile") {
            setStyle({
                a1: "a-bar",
                a2: ""
            })
        } else if (location.pathname === "/profile/insurance") {
            setStyle({
                a1: "",
                a2: "a-bar"
            })
        }
    }, [setStyle, location.pathname])

    const showPicture = (e) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                setAvatarPreview(reader.result);
            }
        };
        reader.readAsDataURL(e.target.files[0]);
        // setPhoto(e.target.files[0])
    };
    const planRedirect = () => {
        history.push('/account-plans');
    }

    return (
        <>
            <div className='profile-head'>
                <h3 className='dashboard-head-title'>Profile</h3>
                <div className='profile-plan'>
                    <p className='change-password'>Change Password?</p>
                    <div onClick={planRedirect} className='plan_'>
                        <img src={plan} alt="" />
                        <div>
                            <p>Account Plan</p>
                            <p className='plan_create'>Creator</p>
                        </div>
                        <img src={arrow} alt="" />
                    </div>
                </div>
            </div>
            <div className='profile-parent load-form'>
                <div className='profile-options'>
                    <div style={{ minWidth: '790px' }}>
                        <Link to="/profile" className={style.a1}>Profile</Link>
                        <Link to="/profile/insurance" className={style.a2}>Insurance</Link>
                        <Link to="/profile">Insurance Agency</Link>
                        <Link to="/profile">Incorporation</Link>
                        <Link to="/profile">Drug Alcohol Program</Link>
                        <Link to="/profile">Drivers</Link>
                        <Link to="/profile">Employees</Link>
                    </div>
                </div>
                {location.pathname === "/profile" ?
                    <>
                        <div encType="multipart/form-data" className='profile-pic-wrapper'>
                            <div className='profile-pic-wrapper2'>
                                <img src={avatarPreview} alt="avatar" />
                                <div className="custom-file">
                                    <div>
                                        <input
                                            type="file"
                                            className="custom-file-input"
                                            id="images"
                                            accept="image/*"
                                            onChange={showPicture}
                                        />
                                        <label htmlFor="images" className="custom-file-label"> <img src={picUpload} alt="avatar" /></label>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <p className='pictext1'>Upload New Image</p>
                                <p className='pictext2'>Maximum size allowed is 2 MB of PNG, JPEG, JPG</p>
                            </div>
                        </div>
                        <Profile />
                    </> : ''}
                <Route path="/profile/insurance"><ProfileInsurance /></Route>
            </div>
        </>
    )
}

export default ProfilePanel